// extracted by mini-css-extract-plugin
module.exports = {"Layout":"_6BXXh","Title":"S6pbK","PromoBlock":"gFLom"};